module.exports = __webpack_public_path__ + "static/media/read_persona.ff4b5fe4.png";